import type { TAdminCompany } from '../../services/models/BillingModels';

/**
 * How the Companies tab and the company page name a company's status. "Lukket" is the ticket's own
 * word for a closed company and stays as it is.
 */

/** Whether a company is open or a superAdmin has closed it. */
export type TCompanyStatus = 'open' | 'closed';

/**
 * A company's status, read off its closing time. An open company may arrive without `closedAtUtc` at
 * all, since the backend host leaves null fields out; absent and null are both open.
 */
export const companyStatusOf = (company: Pick<TAdminCompany, 'closedAtUtc'>): TCompanyStatus => (company.closedAtUtc == null ? 'open' : 'closed');

/** Exhaustive over the union, so a new status is a type error rather than a company shown with no status. */
const companyStatusLabels: Record<TCompanyStatus, string> = {
  open: 'Open',
  closed: 'Lukket',
};

/** How a company's status reads in the list and on its page. */
export const companyStatusLabel = (company: Pick<TAdminCompany, 'closedAtUtc'>): string => companyStatusLabels[companyStatusOf(company)];
